import $ from 'jquery';
import Vue from 'vue';
import '../components/countrySelect';
import '../components/Select2'
import scrollToElement from "scroll-to-element";
import {openingSelect, openSelect, closeSelect} from "../components/Select2";
// import {FormField} from "../components/FormField"

// require('../../sass/components/_fieldsetWrapper.scss');


function slug(countryName) {
    return countryName.replace(' ', '-').replace(',', '').toLowerCase();
}

function isNotIE() {
  let ua, is_ie;
  ua = navigator.userAgent;
  is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
  return !is_ie;
}

function goToSendForm() {
  document.getElementById("wholesaleOpen").click();
  document.getElementById('send_email').scrollIntoView();
  window.location.href.substr(0, window.location.href.indexOf('#'))
}

function goToWholesaleTab() {
  document.getElementById("wholesaleOpen").click();
}

function scrollDifferent() {
  let tab = document.getElementsByClassName("h")[0];
  if(tab.classList.contains('active')){
      let screenPosition;
      let elements = document.getElementsByClassName("dif-price");
      let eParcels = document.getElementsByClassName("dif-parcel-price");
      for (let e = 0; e < elements.length ; e++){
          screenPosition = elements[e].getBoundingClientRect();
              if(elements[e].getAttribute('value') == 'True') {
                  elements[e].classList.add('highlight');
                  setTimeout(function () {
                      elements[e].classList.remove('highlight');
                  }, 750);
              }
      }
      for (let e = 0; e < eParcels.length ; e++) {
          screenPosition = eParcels[e].getBoundingClientRect();
          if (eParcels[e].getAttribute('value') == 'True') {
              eParcels[e].parentElement.classList.add('highlight');
              setTimeout(function () {
                  eParcels[e].parentElement.classList.remove('highlight');
              }, 750);
          }
      }
  }

}

let last_from = '';
let last_to = '';
let is_not_ie = isNotIE();

if ($('#countryFrom') && $('#countryTo')) {
    function redirectToCountry(direction, data) {
        let countryFrom;
        let countryTo;
        let countryId;

        switch (direction) {
            case 'z':
                if (typeof pricingCountryFrom !== 'undefined' && slug(data.text) === 'polska') {
                    if(carrierCode=='gls'){
                        window.location.href = BASE_URL + 'cennik-ups';
                    } else {
                        window.location.href = BASE_URL + 'cennik-' + carrierCode;
                    }
                    return;
                } else {
                    countryFrom = data.id;
                    countryTo = 'PL';
                    countryId = data.id;
                }
                break;
            case 'do':
                if (typeof pricingCountryTo !== 'undefined' && slug(data.text) === 'polska') {
                    if(carrierCode=='gls'){
                        window.location.href = BASE_URL + 'cennik-ups';
                    } else {
                        window.location.href = BASE_URL + 'cennik-' + carrierCode;
                    }
                    return;
                } else {
                    countryFrom = 'PL';
                    countryTo = data.id;
                    countryId = data.id;
                }
                break;

            default:
                return;
        }

        window.location.href = BASE_URL + 'rooting/' + carrierCode + '/' + countryFrom + '/' + countryTo + '/' + countryId;
    }
    
    function setCountries() {
        if (typeof pricingCountryFrom !== 'undefined') {
            $('#countryFrom').val(pricingCountryFrom).trigger('change');
            last_from = {
                text: slug($('#countryFrom option:selected').text()),
                id: pricingCountryFrom.toLowerCase()
            };
        }
        
        if (typeof pricingCountryTo !== 'undefined') {
            $('#countryTo').val(pricingCountryTo).trigger('change');
            last_to = {text: slug($('#countryTo option:selected').text()), id: pricingCountryTo.toLowerCase()};
        }
    }
    $('.country-select').countrySelect({
        call_after_success: setCountries
    });
    $('.country-select').on('select2:opening', function(e) {
        openingSelect(e);
    });
    $('.country-select').on('select2:open', function(e) {
        openSelect(e);
    });
    $('.country-select').on('select2:close', function(e) {
        closeSelect();
    });
    $('#countryFrom').on('select2:select', function(e) {
        redirectToCountry('z', e.params.data)
    });
    $('#countryTo').on('select2:select', function(e) {
        redirectToCountry('do', e.params.data)
    });
}

if(isPallet) {
    var palletPricing = new Vue({
        el: '#pricing-pallet',
        data: palletRetail,

        mounted() {
            this.getPrice();
        },

        methods: {
            getPrice() {
                var idd;
                var prices = []
                var pricesNet = []
                var basicMargin = []
                let zipTo, zipFrom, height, weight, data;
                let _this = this;
                this.price = '';
                this.price_netto = '';
                this.margin_netto = '';
                this.show_margin = false;
                this.loading = true;
                weight = (parseInt(this.weight) > 0) ? +this.weight : 100;
                height = (parseInt(this.height) > 0) ? +this.height : 60;
                zipFrom = (this.zipFrom.length > 0) ? this.zipFrom : '80-371';
                zipTo = (this.zipTo.length > 0 || pricingCountryTo !== 'PL') ? this.zipTo : '80-371';

                for (idd in palletIds) {
                    let productId = palletIds[idd];

                    data = {
                        width: 80,
                        length: 120,
                        weight: weight,
                        height: height,
                        count: 1,
                        'declare-value': '',
                        content: 'test',
                        'parcel-type': 3,
                        'country-to': pricingCountryTo,
                        'country-from': 'PL',
                        'zip-from': zipFrom,
                        'zip-to': zipTo,
                        'product-id': productId,
                        'only-selected-product': true,
                    };

                    if (typeof productId !== 'undefined') {
                        data['product-id'] = productId;
                    }

                    let form_data = JSON.stringify(data)
                    $.ajax({
                        type: 'POST',
                        url: '/ajax/quotation',
                        headers: {"Content-Type": "application/json"},
                        data: form_data,
                        success: function(response) {
                            let key = Object.keys(response.products)[0];
                            let product = response.products[key];
                            if (product.id && product.total > 0) {
                                prices.push(product.total);
                                pricesNet.push(product.total_netto);
                                if (product.basic_margin) {
                                    basicMargin.push(product.basic_margin);
                                }
                            }
                        },
                        async: false
                    })
                }
                setTimeout(() => {
                    this.loading = false;
                    if (prices.length === 0) {
                        _this.price = 'brak oferty';
                        _this.price_netto = 'brak oferty';
                        _this.margin_netto = '0';
                    } else {
                        _this.price = parseFloat(Math.min(...prices) / 100).toFixed(2) + ' zł';
                        _this.price_netto = parseFloat(Math.min(...pricesNet) / 100).toFixed(2) + ' zł';
                        if (basicMargin && basicMargin != undefined && basicMargin.length > 0){
                            _this.margin_netto = parseFloat(Math.min(...basicMargin) / 100).toFixed(2) + ' zł';
                            this.show_margin = true;
                        }
                    }
                }, 200);
            },
        },
    });

    Array.min = function( array ){
        return Math.min.apply( Math, array );
    };

    var palletPricingWholesale = new Vue({
        el: '#pricing-pallet-wholesale',
        data: palletRetail,

        mounted() {
            this.getPrice_wh();
        },

        methods: {
            getPrice_wh() {
                var idd;
                var prices = []
                var pricesNet = []
                var basicMargin = []
                let zipTo, zipFrom, height, weight, data;
                let _this = this;
                this.price_wholesale = '';
                this.price_netto_wholesale = '';
                this.margin_netto_wholesale = '';
                this.show_margin_wholesale = false;
                this.loading = true;
                weight = (parseInt(this.weight) > 0) ? +this.weight : 100;
                height = (parseInt(this.height) > 0) ? +this.height : 60;
                zipFrom = (this.zipFrom.length > 0) ? this.zipFrom : '80-371';
                zipTo = (this.zipTo.length > 0 || pricingCountryTo !== 'PL') ? this.zipTo : '80-371';

                for (idd in palletIds) {
                    let productId = palletIds[idd];

                    data = {
                        width: 80,
                        length: 120,
                        weight: weight,
                        height: height,
                        count: 1,
                        'declare-value': '',
                        content: 'test',
                        'parcel-type': 3,
                        'country-to': pricingCountryTo,
                        'country-from': 'PL',
                        'zip-from': zipFrom,
                        'zip-to': zipTo,
                        'product-id': productId,
                        'only-selected-product': true,
                        'customer_group_id': 1,
                    };

                    if (typeof productId !== 'undefined') {
                        data['product-id'] = productId;
                    }

                    let form_data = JSON.stringify(data)
                    $.ajax({
                        type: 'POST',
                        url: '/ajax/quotation',
                        headers: {"Content-Type": "application/json"},
                        data: form_data,
                        success: function(response) {
                            let key = Object.keys(response.products)[0];
                            let product = response.products[key];

                            if (product.id && product.total > 0) {
                                prices.push(product.total);
                                pricesNet.push(product.total_netto);
                                if (product.basic_margin) {
                                    basicMargin.push(product.basic_margin);
                                }
                            }
                        },
                        async: false
                    })
                }
                setTimeout(() => {
                    this.loading = false;
                    if (prices.length === 0) {
                        _this.price_wholesale = 'brak oferty';
                        _this.price_netto_wholesale = 'brak oferty';
                        _this.margin_netto_wholesale = '0';
                    } else {
                        _this.price_wholesale = parseFloat(Math.min(...prices) / 100).toFixed(2) + ' zł';
                        _this.price_netto_wholesale = parseFloat(Math.min(...pricesNet) / 100).toFixed(2) + ' zł';
                        if (basicMargin && basicMargin != undefined && basicMargin.length > 0){
                            _this.margin_netto_wholesale = parseFloat(Math.min(...basicMargin) / 100).toFixed(2) + ' zł';
                            this.show_margin_wholesale = true;
                        }
                    }
                }, 200);
            },
        },
    });
}

$(function() {
    $('.show-form-email').click(function() {
        scrollToElement(document.getElementById('send_email'));
    });
});

$(function() {
    let hash;
    $('.pricing-tab__link').click(function(e) {
        let i, x, tabcontent, tablinks, tabNames, currentTabClasses, tabClass, parcels, rows;
        tabcontent = document.getElementsByClassName("tabcontent");
        for (let i = 0; i < tabcontent.length; i++) {
            tabcontent[i].classList.remove('show');
        }
        tablinks = document.getElementsByClassName("pricing-tab__link");
        for (let i = 0; i < tablinks.length; i++) {
            tablinks[i].classList.remove('active');
        }
        tabNames = document.getElementsByClassName(e.currentTarget.name);
        for (let i = 0; i < tabNames.length; i++) {
            tabNames[i].classList.add('show');
        }
        currentTabClasses = e.currentTarget.className.split(" ")[1];
        tabClass = document.getElementsByClassName(currentTabClasses);
        if(tabClass) {
            for (let i = 0; i < tabClass.length; i++) {
                tabClass[i].classList.add('active');
            }
        }

        if (is_not_ie) {
            parcels = document.getElementsByClassName("dif-parcel-price");
            for (let x = 0; x < parcels.length; x++) {
                if(parcels[x].getAttribute('value') === 'True'){
                    parcels[x].parentElement.classList.add('highlight');
                    setTimeout(function () {
                        parcels[x].parentElement.classList.remove('highlight');
                    }, 750);
                }
            }
            rows = document.getElementsByClassName("dif-price");
            for (let x = 0; x < rows.length; x++) {
                if(rows[x].getAttribute('value') === 'True'){
                    rows[x].classList.add('highlight');
                    setTimeout(function () {
                        rows[x].classList.remove('highlight');
                    }, 750);
                }
            }
        }
        if(isPallet) {
            var pricing_retail = document.getElementById('pricing-pallet');
            var pricing_wholesale = document.getElementById('pricing-pallet-wholesale');
            if (e.currentTarget.id == 'defaultOpen') {
                pricing_wholesale.classList.add('hide1');
                pricing_wholesale.classList.remove('show1');
                pricing_retail.classList.add('show1');
                pricing_retail.classList.remove('hide1');
                palletPricing.getPrice();
            } else if (e.currentTarget.id == 'wholesaleOpen') {
                pricing_retail.classList.add('hide1');
                pricing_retail.classList.remove('show1');
                pricing_wholesale.classList.add('show1');
                pricing_wholesale.classList.remove('hide1');
                palletPricingWholesale.getPrice_wh();
            }
        }
    });
    hash = document.location.hash;
    if (hash == '#email_form') {
        goToSendForm();
    }
    if (hash == '#ceny-hurtowe') {
        goToWholesaleTab();
    }
});

if (is_not_ie) {
    window.onscroll = function() {scrollDifferent()};
}

let firstColMobile = document.getElementsByClassName("first_col_mobile");
let weight_box_retail = document.getElementsByClassName("colored_weight_retail")
let weight_box_wholesale = document.getElementsByClassName("colored_weight_wholesale")
let netto_box_retail = document.getElementsByClassName("colored_netto_retail")
let netto_box_wholesale = document.getElementsByClassName("colored_netto_wholesale")
let brutto_box_retail = document.getElementsByClassName("colored_brutto_retail")
let brutto_box_wholesale = document.getElementsByClassName("colored_brutto_wholesale")
let box_colors = ["white", "#ededed"];

for(let i=0, j=0 ; i < weight_box_retail.length; i++, j++) {
    if(i>0 && i%firstColMobile[1].childElementCount==0){
        weight_box_retail[i].style.background = box_colors[j%2];
        netto_box_retail[i].style.background = box_colors[j%2];
        brutto_box_retail[i].style.background = box_colors[j%2];
        if(i%2==0){
            netto_box_retail[i].classList.add('dif-price');
            brutto_box_retail[i].classList.add('dif-price');
        }
    } else {
        weight_box_retail[i].style.background = box_colors[j%2];
        netto_box_retail[i].style.background = box_colors[j%2];
        brutto_box_retail[i].style.background = box_colors[j%2];
        if(i%2==0){
            netto_box_retail[i].classList.add('dif-price');
            brutto_box_retail[i].classList.add('dif-price');
        }
    }
    if (weight_box_retail[i].classList.contains('p_last')) {
        j = 1;
    }
 }

for(let i=0, j=0 ; i < weight_box_wholesale.length; i++, j++) {
    if(i>0 && i%firstColMobile[1].childElementCount==0){
        weight_box_wholesale[i].style.background = box_colors[j%2];
        netto_box_wholesale[i].style.background = box_colors[j%2];
        brutto_box_wholesale[i].style.background = box_colors[j%2];
        if(i%2==0){
            netto_box_wholesale[i].classList.add('dif-price');
            brutto_box_wholesale[i].classList.add('dif-price');
        }
    } else {
        weight_box_wholesale[i].style.background = box_colors[j%2];
        netto_box_wholesale[i].style.background = box_colors[j%2];
        brutto_box_wholesale[i].style.background = box_colors[j%2];
        if(i%2==0){
            netto_box_wholesale[i].classList.add('dif-price');
            brutto_box_wholesale[i].classList.add('dif-price');
        }
    }
    if (weight_box_wholesale[i].classList.contains('p_last')) {
        j = 1;
    }
 }

// new Vue({
//     el: '#group_choose',
//     data() {
//         return {
//             type: null
//         };
//     },
//     watch: {
//         type(newVal, oldVal) {
//             let elements = document.querySelectorAll('[data-type]');
//             elements.forEach(el => {
//               el.style.display = 'none';
//             });
//             let show = document.querySelectorAll('[data-type="'+newVal+'"]');
//             show.forEach(el => {
//               el.style.display = 'block';
//             });
//         }
//     }
// })

new Vue({
    el: '#group_choose',
    data() {
        return {
            type: null // Początkowo null
        };
    },
    mounted() {
        // Po załadowaniu komponentu ustaw domyślną wartość na pierwszy radio, jeśli type jest null
        if (this.type === null) {
            const firstRadio = document.querySelector('[data-type]');
            if (firstRadio) {
                this.type = firstRadio.getAttribute('data-type'); // Ustawiamy wartość pierwszego data-type
            }
        }
    },
    watch: {
        type(newVal, oldVal) {
            // Ukryj wszystkie elementy z data-type
            let elements = document.querySelectorAll('[data-type]');
            elements.forEach(el => {
                el.style.display = 'none';
            });

            // Jeśli newVal jest null, ustawiamy widoczność pierwszego elementu
            if (newVal === null) {
                const firstElement = document.querySelector('[data-type]');
                if (firstElement) {
                    firstElement.style.display = 'block';
                    this.type = firstElement.getAttribute('data-type'); // Aktualizujemy type
                }
            } else {
                // Pokaż elementy z wybranym data-type
                let show = document.querySelectorAll('[data-type="' + newVal + '"]');
                show.forEach(el => {
                    el.style.display = 'block';
                });
            }
        }
    }
});

